var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTropical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76 4.84078L4.96 3.05078L3.55 4.46078L5.34 6.25078L6.76 4.84078ZM1 10.5008H4V12.5008H1V10.5008ZM11 0.550781H13V3.50078H11V0.550781ZM19.04 3.04578L20.448 4.45278L18.658 6.24278L17.251 4.83478L19.04 3.04578ZM17.24 18.1608L19.03 19.9608L20.44 18.5508L18.64 16.7608L17.24 18.1608ZM20 10.5008H23V12.5008H20V10.5008ZM12 5.50078C8.69 5.50078 6 8.19078 6 11.5008C6 14.8108 8.69 17.5008 12 17.5008C15.31 17.5008 18 14.8108 18 11.5008C18 8.19078 15.31 5.50078 12 5.50078ZM12 15.5008C9.79 15.5008 8 13.7108 8 11.5008C8 9.29078 9.79 7.50078 12 7.50078C14.21 7.50078 16 9.29078 16 11.5008C16 13.7108 14.21 15.5008 12 15.5008ZM11 19.5008H13V22.4508H11V19.5008ZM3.55 18.5408L4.96 19.9508L6.75 18.1508L5.34 16.7408L3.55 18.5408Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTropical);
export default __webpack_public_path__ + "static/media/tropical.6be6bcff05cdf00e1a2edab15e775aff.svg";
export { ForwardRef as ReactComponent };